import { BehaviorSubject } from 'rxjs';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import type { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ModalService } from '@bp/shared/features/modal';
import { Destroyable, takeUntilDestroyed } from '@bp/shared/models/common';
import { EnvironmentService } from '@bp/shared/services';

import { MOBILE_MENU_DIALOG_ID } from '../modal-menu';

@Component({
	selector: 'bp-header',
	templateUrl: './header.component.html',
	styleUrls: [ './header.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.on-top]': 'mobileMenuDialog$.value',
	},
})
export class HeaderComponent extends Destroyable {

	mobileMenuDialog$ = new BehaviorSubject<MatDialogRef<any> | undefined>(undefined);

	constructor(
		public environment: EnvironmentService,
		private readonly _modalService: ModalService,
		private readonly _router: Router,
	) {
		super();

		this._modalService
			.getOpenDialogById$(MOBILE_MENU_DIALOG_ID)
			.pipe(takeUntilDestroyed(this))
			.subscribe(this.mobileMenuDialog$);
	}

	openMobileMenu(): void {
		void this._router.navigate([{ outlets: { modal: [ 'menu' ]} }]);
	}

}
